import { useState } from 'react'
import { Menu, X, ChevronDown } from 'lucide-react'

const NAV_GROUPS = [
  { label: 'Ecosystem', items: ['MEYOO OS','FULL ECOSYSTEM','WORKSPACE & SQL','THE 9 HUBS','WORKSTATION','STUDIO','SELF-BUILDING'] },
  { label: 'Learn & Grow', items: ['QURAN & SEERAH','SOUL PROFILE','DASHBOARD','MIND WELLNESS','SKILL GRAPH'] },
  { label: 'Build', items: ['START DOOR','APP STUDIO','VIDEO SHOWCASE','MARKETPLACE'] },
  { label: 'About', items: ['FOUNDER','EVIDENCE','SAFETY','ABOUT'] },
]

export default function Navbar(){
  const [mobileOpen,setMobileOpen]=useState(false)
  const [openGroup,setOpenGroup]=useState<string|null>(null)

  return (
    <nav className="sticky top-0 z-50 w-full bg-slate-950/80 backdrop-blur-xl border-b border-slate-800/50">
      <div className="max-w-7xl mx-auto px-6 h- flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-emerald-500 flex items-center justify-center font-bold text-white">m</div>
          <div className="leading-none">
            <div className="font-bold text-white tracking-tight">meUus</div>
            <div className="text- text-slate-400 tracking-[0.2em]">me → U → us</div>
          </div>
          <span className="ml-4 hidden md:inline-flex px-2.5 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/20 text- text-emerald-400 font-semibold tracking-wider">STARTING POINT</span>
        </div>

        <div className="hidden lg:flex items-center gap-1">
          {NAV_GROUPS.map(g=>(
            <div key={g.label} className="relative">
              <button onClick={()=>setOpenGroup(openGroup===g.label?null:g.label)} className="px-3 py-2 text- font-semibold tracking-wider text-slate-300 hover:text-white flex items-center gap-1">
                {g.label} <ChevronDown className="w-3 h-3" />
              </button>
              {openGroup===g.label && (
                <div className="absolute top-full left-0 mt-2 w-56 bg-slate-900 border border-slate-800 rounded-xl shadow-2xl p-2">
                  {g.items.map(it=>(
                    <a key={it} href={`#${it.toLowerCase().replace(/ & /g,'-').replace(/\s+/g,'-')}`} className="block px-3 py-2 text-xs text-slate-300 hover:text-white hover:bg-slate-800 rounded-lg">{it}</a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a href="#start" className="hidden md:inline-flex px-4 py-2 bg-emerald-600 hover:bg-emerald-500 text-white rounded-full text-xs font-bold">Enter</a>
          <button onClick={()=>setMobileOpen(!mobileOpen)} className="lg:hidden p-2 text-slate-300">{mobileOpen? <X /> : <Menu />}</button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-slate-950 border-t border-slate-800 p-4 space-y-4">
          {NAV_GROUPS.map(g=>(
            <div key={g.label}>
              <div className="text- font-bold text-slate-500 tracking-wider mb-2">{g.label}</div>
              <div className="grid grid-cols-2 gap-1">
                {g.items.map(it=><a key={it} href={`#${it.toLowerCase().replace(/ /g,'-')}`} className="text-xs text-slate-300 py-1.5">{it}</a>)}
              </div>
            </div>
          ))}
        </div>
      )}
    </nav>
  )
}
